export default __webpack_public_path__ + "static/media/treatment-icon.cb8280a0.svg";